import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  PagingResponseModel,
} from "../shared";
import { RateChargeContainerModel } from "../../../../../models/aggregates/pgw/ratecharge.model";
import { RateChargeCriteriaModelQuery, RateChargeQueryCriteriaClass } from "../../criteria/pgw/ratecharge-criteria.model";

@Injectable({
  providedIn: "root",
})
export class RateChargeService extends BaseApiTemplateService<RateChargeContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "merchant/rate-hdrs";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "merchant/rate-hdrs";
    this.httpClient = http;
  }

  getRateChargeByCriteria(
    visa: ApiVisa,
    criteria?: RateChargeQueryCriteriaClass
  ): Observable<PagingResponseModel<RateChargeContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildRateChargeCriteriaCriteria = new RateChargeCriteriaModelQuery(criteria);
    console.log("query", buildRateChargeCriteriaCriteria.query);
    return this.httpClient.get<PagingResponseModel<RateChargeContainerModel>>(
      this.apiUrl + "/query?" + buildRateChargeCriteriaCriteria.query,
      this.getHttpHeader(visa)
    );
  }
}
